// extracted by mini-css-extract-plugin
export default {"container":"pOmUbd","inner":"brIYTo","slide":"hpOf1d","prevActive":"p0JGCy","active":"iHSeC2"};